import React from 'react';
import './CommissionsInline.css';

export default function CommissionsInline() {
  return (
    <div className="ci-wrap">
      {/* Left — giant rotated title */}
      <div className="ci-left">
        <h2 className="ci-title">COMMISSIONS</h2>
      </div>

      {/* Right — content */}
      <div className="ci-right">
        <div className="ci-status">
          <span className="ci-status-dot ci-status-dot--closed" />
          <p className="ci-status-text">Currently CLOSED for custom commissions</p>
        </div>

        <div className="ci-block">
          <h3 className="ci-heading">How it works</h3>
          <p className="ci-body">
            Describe your idea — a character, a scene, a vibe — and I'll build it from scratch.
            Anime-styled, bold, character-driven work only.
          </p>
        </div>

        <div className="ci-block">
          <h3 className="ci-heading">Get started</h3>
          <p className="ci-body">Drop me a message when commissions reopen:</p>
          <div className="ci-links">
            <a
              href="https://vgen.co/knowndisc"
              className="ci-btn ci-btn--primary"
              target="_blank" rel="noopener noreferrer"
            >
              <span>Commission on VGen</span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </a>
            <a
              href="mailto:knowndisc.questionmail@gmail.com"
              className="ci-btn ci-btn--secondary"
            >
              <span>Email Me</span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M22 6L12 13L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </a>
          </div>
        </div>
      </div>

      {/* Decorative cross */}
      <div className="ci-deco-cross" aria-hidden="true" />
    </div>
  );
}
